import { createSlice } from "@reduxjs/toolkit";

export const selectedPatientSlice = createSlice({
  name: "selectedPatient",
  initialState: {
    value:undefined
  },
  reducers: {
    updateSelectedPatient: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateSelectedPatient } = selectedPatientSlice.actions;

export default selectedPatientSlice.reducer;
